export enum RecordStatus {
  GM_LOCKED = 'GM_LOCKED',
  GM_SYNCED = 'GM_SYNCED',
  GM_EDITED = 'GM_EDITED',
  MANUAL_ADD = 'MANUAL_ADD'
}